import { transferHistory } from '../services/components/transfer_history.jsx'


export const getTransferHistory = (cardDetailId, startDate, endDate, status) => dispatch => {
    let state = ""
    transferHistory((data, msg, status) => {
        if (msg === "success") {
            state = {
                message: "Success",
                status: 200,
                body: data
            }
        } else {
            state = data
        }
        dispatch({ type: "TRANS_HISTORY", payload: state })
    }, cardDetailId, startDate, endDate, status)
}







// WEBPACK FOOTER //
// ./src/actions/gettransferhistory.jsx